export const externalLocations = {
  termsOfUse: 'https://www.zooz.com/legal/terms-of-use',
  privacyPolicy: 'https://www.zooz.com/legal/privacy-policy',
  zoozWebsite: 'https://www.zooz.com',
  zoozSupportMail: 'support@zooz.com'
}
